import axios from "axios";

const baseURL = process.env.REACT_APP_API_BASE_URL;
const conditionTypesUrl = `${baseURL}/produto/cobranca/configuracoes/condition-types`;

const getToken = () => {
  const rawToken =
    localStorage.getItem("jwtToken") ||
    localStorage.getItem("authToken") ||
    localStorage.getItem("token") ||
    sessionStorage.getItem("jwtToken") ||
    sessionStorage.getItem("authToken") ||
    sessionStorage.getItem("token");

  if (!rawToken) throw new Error("Token não encontrado.");
  return rawToken.startsWith("Bearer ") ? rawToken.slice(7) : rawToken;
};

const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

const normalizeConditionTypes = (conditionTypes) => {
  if (!Array.isArray(conditionTypes)) {
    throw new Error("A resposta de condition types não contém uma lista.");
  }

  const normalized = conditionTypes.map((conditionType) => {
    if (typeof conditionType !== "string") {
      throw new Error("A lista de condition types contém um código inválido.");
    }

    const code = conditionType.trim();
    if (!code) throw new Error("Os códigos de condition type não podem ficar vazios.");
    if (code.length > 50) throw new Error("Cada código de condition type pode ter até 50 caracteres.");
    return code;
  });

  const keys = normalized.map((code) => code.toUpperCase());
  if (new Set(keys).size !== keys.length) {
    throw new Error("A lista não pode conter códigos duplicados.");
  }

  return normalized;
};

const getConditionTypesExcluidos = async () => {
  const response = await axios.get(conditionTypesUrl, { headers: authHeaders() });
  return normalizeConditionTypes(response?.data);
};

const saveConditionTypesExcluidos = async (conditionTypes) => {
  const conditionTypesExcluidos = normalizeConditionTypes(conditionTypes);
  const response = await axios.put(
    conditionTypesUrl,
    { conditionTypesExcluidos },
    { headers: authHeaders() },
  );

  return normalizeConditionTypes(response?.data);
};

const getApiErrorMessage = (err, fallbackMessage) => {
  const responseData = err?.response?.data;

  if (typeof responseData === "string" && responseData.trim()) return responseData;
  if (responseData?.mensagem) return responseData.mensagem;
  if (responseData?.message) return responseData.message;
  if (responseData?.erro) return responseData.erro;
  if (responseData?.detail) return responseData.detail;
  if (err?.response?.status === 401) return "Sessão expirada ou token inválido.";
  if (err?.response?.status === 403) {
    return "Acesso ao produto Cobrança ou permissão de gestor necessária para esta operação.";
  }

  return err?.message || fallbackMessage;
};

const cobrancaConfiguracoesService = {
  getApiErrorMessage,
  getConditionTypesExcluidos,
  saveConditionTypesExcluidos,
};

export default cobrancaConfiguracoesService;
